import 'dayjs/locale/nl'
import './App.css'
import './i18n'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import i18n from 'i18next'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Smartlook from 'smartlook-client'

import { clearFormProgress } from '@/hooks/useTrackFormProgress.ts'
import { isVelthuis } from '@/utils/common.ts'

dayjs.extend(localeData)
dayjs.extend(customParseFormat)

clearFormProgress()

const App = () => {
  useEffect(() => {
    dayjs.locale(i18n.language)
  }, [i18n.language])

  // init smartlook for velthuis
  useEffect(() => {
    if (isVelthuis) {
      const projectId = import.meta.env.VELTHUIS_SMARTLOOK_KEY
      Smartlook.init(projectId, { region: 'eu' })
    }
  }, [])

  return <Outlet />
}

export default App
